import { Modal, Paper, Typography } from '@mui/material';
import { ValidationsErrorDialogStyles } from './styles';
import { PoiBulkUploadActionTypes, useBulkUploadPoiActions } from '../actions';
import { IdmsErrorTable } from '@/components/Analysis/Idms/IdmsErrorTable';
import { xlsxBase64ToJson } from '@/components/Analysis/Idms/utils';
import { useEffect, useState } from 'react';

export const ValidationsErrorDialog = () => {
  const { state, dispatch } = useBulkUploadPoiActions();
  const errors = state.errors;
  const isOpen = state.modal === 'validation';

  const [data, setData] = useState<
    | {
        header: string[];
        rows: Array<Record<string, unknown>>;
      }
    | undefined
  >();

  const onClose = () => {
    dispatch({ type: PoiBulkUploadActionTypes.CLOSE_ALL_MODALS });
  };

  useEffect(() => {
    (async () => {
      if (state.input?.csv) {
        const data = await xlsxBase64ToJson(state?.input?.csv);
        setData(data);
      }
    })();
  }, [state.input?.csv]);

  if (!data) return <></>;
  if (!isOpen) return <></>;

  const { header, rows } = data;

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Paper sx={ValidationsErrorDialogStyles}>
        <Typography fontWeight={'bold'} fontSize={20} my={2}>
          The file contains errors
        </Typography>
        <Typography>
          Note: This file cannot be uploaded due to exceptions highlighted in the table below. Hover
          over each highlighted value to view the specific exception.
        </Typography>
        <IdmsErrorTable errors={errors?.issue.error || []} header={header} rows={rows} />
      </Paper>
    </Modal>
  );
};
